document.addEventListener("DOMContentLoaded", function() {
  var quizSteps = document.querySelectorAll('.quiz-step');

  quizSteps.forEach(function(step, index) {
    var optionCards = step.querySelectorAll('.option-card');
    var continueBtn = step.querySelector('.continue-btn');

    // For spørgsmål fra andet og frem skal continue-knappen startes som deaktiveret
    if (continueBtn && index > 0) {
      continueBtn.disabled = true;
      continueBtn.classList.add('disabled');
    }

    // Tilføj click-event til alle option-cards
    optionCards.forEach(function(card) {
      card.addEventListener('click', function() {
        // Find den overordnede quiz-step for den pågældende option
        var step = card.closest('.quiz-step');
        // Tjek om spørgsmålet er multiple choice – data-attributten skal være "true" for at tillade flere svar
        var multipleChoice = step.getAttribute('data-multiple-choice');

        if(multipleChoice !== "true") {
          // Single choice: Fjern 'selected' fra alle option-cards i denne quiz-step og tilføj til den klikkede
          var siblings = step.querySelectorAll('.option-card');
          siblings.forEach(function(sib) {
            sib.classList.remove('selected');
          });
          card.classList.add('selected');
        } else {
          // Multiple choice: Toggle den valgte option
          card.classList.toggle('selected');
        }

        // For spørgsmål fra andet og frem: tjek om mindst én option er valgt og opdater continue-knappen
        if (continueBtn && index > 0) {
          var anySelected = step.querySelector('.option-card.selected') !== null;
          if (anySelected) {
            continueBtn.disabled = false;
            continueBtn.classList.remove('disabled');
          } else {
            continueBtn.disabled = true;
            continueBtn.classList.add('disabled');
          }
        }
      });
    });

    // Når der klikkes på continue-knappen: forhindr klik hvis knappen er deaktiveret
    if (continueBtn) {
      continueBtn.addEventListener('click', function(e) {
        if (continueBtn.disabled) {
          e.preventDefault();
          return false;
        }
        var currentIndex = Array.prototype.indexOf.call(quizSteps, step);
        var nextStep = currentIndex + 1;
        if (nextStep < quizSteps.length) {
          showStep(nextStep);
        }
      });
    }
  });

  // Opsæt skip-links: klik på skip går direkte til thank you-steppet
  var skipLinks = document.querySelectorAll('.quiz-step:not(.quiz-thank-you) .skip-link');
  skipLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      for (var i = 0; i < quizSteps.length; i++) {
        if (quizSteps[i].classList.contains('quiz-thank-you')) {
          showStep(i);
          break;
        }
      }
    });
  });

  // Start med det første trin
  showStep(0);

  // Opsæt accordion-funktionalitet, hvis funktionen findes
  if (typeof setupAccordion === "function") {
    setupAccordion();
  }
});

function showStep(index) {
  var quizSteps = document.querySelectorAll('.quiz-step');
  quizSteps.forEach(function(step, i) {
    step.style.display = (i === index) ? 'block' : 'none';
  });
  updateProgressBar(index);

  // Hvis thank you-steppet vises, kør transitionen
  var currentStep = quizSteps[index];
  if (currentStep && currentStep.classList.contains('quiz-thank-you')) {
    var transitionContainer = document.getElementById("thankyou-transition");
    var thankyouContent = document.getElementById("thankyou-content");
    if (transitionContainer && thankyouContent) {
      transitionContainer.style.display = 'flex';
      thankyouContent.style.display = 'none';

      setTimeout(function(){
        var transitionText = transitionContainer.querySelector(".transition-text");
        if (transitionText) {
          transitionText.innerText = "Næsten færdig...";
        }
      }, 2200);

      setTimeout(function(){
        transitionContainer.style.display = "none";
        thankyouContent.style.display = "block";

        // Skjul progress bar
        var progressContainer = document.querySelector('.progress-container');
        if (progressContainer) {
          progressContainer.style.display = 'none';
        }

        // Vis "Quiz Results Verified" announcement bar
        var verifiedBar = document.querySelector('.quiz-verified-announcement');
        if (verifiedBar) {
          verifiedBar.style.display = 'block';
        }

        // Start confetti-effekten
        if (typeof confetti === 'function') {
          confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.6 }
          });
        }
      }, 4500);
    }
  }
}

function updateProgressBar(currentIndex) {
  var quizSteps = document.querySelectorAll('.quiz-step:not(.quiz-thank-you)');
  var progressFill = document.querySelector('.progress-fill');
  if (!progressFill || quizSteps.length === 0) return;
  var percentage = (currentIndex / quizSteps.length) * 100;
  progressFill.style.width = percentage + '%';
}
